import React, { FC, useMemo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";
import { style as itemDetailHeaderStyle } from "./ItemDetailHeader.style";

interface ItemDetailHeaderProps {
  readonly onBack: () => void;
}
const ItemDetailHeader: FC<ItemDetailHeaderProps> = ({ onBack }) => {
  const title = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HEADER_CHECKOUT_TITLE });

  const style = useMemo(() => itemDetailHeaderStyle(), []);

  return (
    <Header testID="item-detail-header">
      <ButtonIconPlaceholder />
      <Text level={3} variant="action">
        {title}
      </Text>
      <ButtonIcon name="close" style={{ button: style.button }} testID="close-button-icon" onPress={onBack} />
    </Header>
  );
};

export { ItemDetailHeader };
